import React from 'react'

import { niceJoin } from '../../lib/formats'
import DataGrid from '../UI/DataGrid'
import UserCard from './UserCard'

const ListUsers = () => {
  const gridColumns = [
    { name: 'id', title: 'ID' },
    { name: 'fullName', title: 'Name' },
    { name: 'title', title: 'Title' },
    { name: 'email', title: 'E-mail' },
    { name: 'formattedPhones', title: 'Phones' },
    { name: 'roles', title: 'Roles' }
  ]

  const gridRowMappingFn = user => {
    const id = user.id
    const { fullName, title, email, formattedPhones, roles } = user.attributes

    return {
      id: id,
      fullName: fullName,
      title: title,
      email: email,
      formattedPhones: formattedPhones,
      roles: niceJoin(roles)
    }
  }

  const gridSorting = [{ columnName: 'fullName', direction: 'asc' }]
  const gridHiddenColumns = ['id']
  const tableColumnVisibilityExtensions = [
    { columnName: 'id', togglingEnabled: false },
    { columnName: 'fullName', togglingEnabled: false }
  ]

  return (
    <DataGrid
      resourceAPIEndpoint="users"
      resourceSingularName="user"
      resourcePluralName="users"
      nameAttribute="name"
      clientRootPath="/users"
      gridColumns={gridColumns}
      gridRowMappingFn={gridRowMappingFn}
      gridSorting={gridSorting}
      gridHiddenColumns={gridHiddenColumns}
      tableColumnVisibilityExtensions={tableColumnVisibilityExtensions}
      detailsCard={UserCard}
    />
  )
}

export default ListUsers



// WEBPACK FOOTER //
// ./src/components/Users/ListUsers.jsx